module.exports = __webpack_public_path__ + "static/media/results-tip-icon4.c5a0daae.png";